module.exports = __webpack_public_path__ + "media/images/pages/about-80d8d2b6ee5d2dc14df7b80b0afde2b9.jpg";